import { useQuery } from '@tanstack/react-query';
import PleaseWait from 'components/loader/PleaseWait';
import Shows from 'components/program/Shows';
import { getCultureProgram } from 'lib/client/movieinfo';
import { ITheatreProgram } from 'lib/types/Program';
import styled from 'styled-components';
import AllCultureShowsLink from 'components/frontpage/culture/AllCultureShowsLink';
import { toRem } from 'lib/client/fonts';

//#region [Styles]
const SCultureProgram = styled.section`
	margin-top: 3.125rem;
	margin-bottom: 3.125rem;

	@media screen and (max-width: 640px) {
		padding: 10px;
	}

`;

const SProgramTitle = styled.h1`
	text-align: center;
	text-transform: uppercase;
	font-size: ${toRem(31)};
	font-weight: var(--font_bold, bold);

`;

const SNoShows = styled.p`
	text-align: center;
`;
//#endregion

//#region [Props]
type ShowsForCultureProps = {
	kulnr: string;
	nynorsk: boolean;
};
//#endregion

//#region [Component]
export default function ShowsForCulture({ kulnr, nynorsk }: ShowsForCultureProps) {
	const { isLoading, isError, data, error, isFetching } = useQuery({
		queryKey: ["culture", kulnr], // key
		queryFn: () => getCultureProgram(kulnr, undefined, false), // loader function
		refetchOnWindowFocus: false,
		refetchInterval: 600000, // refretch automatically every 10 minutes
		staleTime: 599999,
	} // options
	);
	return (<SCultureProgram>
		<SProgramTitle>{nynorsk ? "Framsyningar" : "Forestillinger"}</SProgramTitle>
		{isLoading && <PleaseWait text="Henter programmet" />}
		{!isLoading && (data?.shows?.length ?? 0) === 0 && <SNoShows>{nynorsk ? "framsyningar" : "forestillinger"}</SNoShows>}
		{!isLoading && (data?.shows?.length ?? 0) > 0 && <Shows data={data} />}

	</SCultureProgram>);
}
//#endregion